import Vue from 'vue'

export const Events = new Vue()
